export default import.meta.ROLLUP_FILE_URL_aNc_T6RhmwbmKzyPcGN9oQ